export const PriceSummaryModel = Backbone.Model.extend({
    connect: true,
    selectors: ['primeStatus'],
    defaults: {
        primeStatus: {},
    },
    getMembershipSubscriptionDetails() {
        const {membershipSubscriptionDetails} = this.get('primeStatus');
        return membershipSubscriptionDetails;
    },
    isFreeTrial() {
        const {membershipPeriod} = this.getMembershipSubscriptionDetails();
        return 'FREE_TRIAL' === membershipPeriod;
    },
    getMembershipSubscriptionOfferDTO() {
        const {membershipSubscriptionOfferDTO} = this.getMembershipSubscriptionDetails();
        return membershipSubscriptionOfferDTO;
    },
    getSubscriptionPrice() {
        const {price} = this.getMembershipSubscriptionOfferDTO();
        return price || 0;
    },
    getSubscriptionDuration() {
        const {duration} = this.getMembershipSubscriptionOfferDTO();
        return duration || 30;
    },
    isSubscriptionAdded() {
        const {primeMemberSelected} = this.get('primeStatus');
        return primeMemberSelected && primeMemberSelected.isSubscriptionAdded;
    },
});
